export default "__VITE_ASSET__48fe78ca__"